<template>
  <el-col :span="widthSpan" class="table-echart" ref="tc">
    <div class="table-echart-content" :style="{ border: `2px solid ${color}`, height: heightSpan }">
      <div class="table-chart-title" :style="{ backgroundColor: color }">
        {{ title }}
        <div class="title-buttons">
          <div class="button-item" @click="sizeHandler">
            <em class="el-icon-full-screen"></em>
          </div>
        </div>
      </div>
      <div class="table-echart-box">
        <div class="table-box">
          <el-table :data="tableData" border max-height="200" size="mini">
            <el-table-column
              v-for="(v, i) in tableColumn"
              :key="i"
              :label="v"
              :prop="v"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div class="chart-box">
          <v-chart :options="chartOption" :autoresize="true" :name="canvasName"></v-chart>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
// import screenfull from 'screenfull';
export default {
  props: {
    tableColumn: Array,
    tableData: Array,
    chartOption: Object,
    title: String,
    color: {
      type: String,
      default: '#2b73b9'
    },
    canvasName: {
      type: String,
      required: true
    },
    normalSpan: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      widthSpan: this.normalSpan,
      heightSpan: '500px'
    };
  },
  methods: {
    sizeHandler() {
      // if (screenfull.isEnabled) {
      //   screenfull.toggle(this.$refs['tc']);
      // }
      if (this.widthSpan === this.normalSpan) {
        this.widthSpan = 24;
        this.heightSpan = '600px';
      } else {
        this.widthSpan = this.normalSpan;
        this.heightSpan = '500px';
      }
    }
  }
};
</script>

<style lang="scss">
.table-echart {
  margin-bottom: 15px;
  transition: all 0.3s;
  .table-echart-content {
    background-color: var(--cotton-table-chart-bg, $bg-color);
  }
  .table-chart-title {
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: var(--cotton-table-chart-title-color, #fff);
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 2px;
    position: relative;
    .title-buttons {
      height: 100%;
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      .button-item {
        height: 100%;
        width: 32px;
        text-align: center;
        line-height: 32px;
      }
    }
  }
  .table-echart-box {
    height: calc(100% - 32px);
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .table-box,
    .chart-box {
      width: 100%;
      height: 50%;
    }
    .chart-box {
      overflow: hidden;
    }
  }
}
</style>
